import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  height: 0.5rem;
  position: relative;
  border-radius: 0.25rem;
  overflow: hidden;
`

const Track = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.gray200};
`

const Fill = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 50%;
  background-color: ${props => props.theme.colors.interactive};
  transition: width 250ms ease;
`

export default ({ min, max, value, ...rest }) => {
  const fraction = (value - min) / (max - min)
  return (
    <Wrapper {...rest}>
      <Track />
      <Fill style={{ width: `${fraction * 100}%` }} />
    </Wrapper>
  )
}
